<template>
  <div class="py-5">
    <div class="container">
      <h1 class="fw-light text-poppins">{{ $t('royalties_works_title') }}</h1>
      <p v-html="$t('royalties_works_descripcion')"></p>
      <ol class="mt-4 mb-4">
        <li class="mt-3">{{ $t('royalties_works_list_1') }}</li>
        <li class="mt-3">{{ $t('royalties_works_list_2') }}</li>
        <li class="mt-3">{{ $t('royalties_works_list_3') }}</li>
      </ol>
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="bg-light text-dark p-2">
            <h3 class="fw-bold mb-0 text-poppins">{{ $t('distribution') }}</h3>
          </div>
          <ul class="list-unstyled p-2">
            <li class="py-1">
              {{ $t('landing_distribution_1') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_2') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_3') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_4') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_5') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_6') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_7') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_distribution_8') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
          </ul>
          <div class="bg-light text-dark p-2">
            <h3 class="fw-bold mb-0 text-poppins">{{ $t('analytics') }}</h3>
          </div>
          <ul class="list-unstyled p-2">
            <li class="py-1">
              {{ $t('landing_analytics_1') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_analytics_2') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_analytics_3') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing_analytics_4') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="row no-gutters">
            <div class="col-store-mobile col-sm-3 col-md-3" v-for="(store, index) in stores" v-bind:key="`store_${index}`">
              <div class="animated-padding p-1">
                <a target="_blank" href="https://help.indiefy.net/hc/en-us/articles/360045732514-Which-stores-does-Indiefy-distribute-to-">
                  <img class="animated zoomIn" width="100%" :src="`/static/img/landing/stores/${store}.png`" :alt="`Store ${store}`">
                  <span style="position: absolute; z-index: -1;" v-if="isCrawler">Store {{ store }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-5">
        <router-link :to="distributeNowLink" class="btn btn-lg btn-success">
          {{ $t('distribute_now') }}
        </router-link>
      </div>
      <h2 class="h1 fw-light animated fadeInLeft mt-5 text-poppins">{{ $t('landing.social_video_monetization.title') }}</h2>
      <div class="row mt-4">
        <div class="col-md-6">
          <div>{{$t('landing.social_video_monetization.info_1')}}</div>
            <div class="container my-5">
              <div class="d-flex justify-content-around mb-3">
                <div class="p-2"><i class="fab fa-facebook fa-5x"></i></div>
                <div class="p-2"><i class="fab fa-instagram fa-5x"></i></div>
                <div class="p-2"><i class="fab fa-youtube fa-5x"></i></div>
              </div>
            </div>
          <div class="mb-3">{{$t('landing.social_video_monetization.info_2')}}</div>
          <div>
            {{$t('landing.social_video_monetization.info_3')}}
            <a rel="noopener noreferrer" href="https://help.indiefy.net/hc/en-us/articles/360045732514-Which-stores-does-Indiefy-distribute-to-" target="_blank">{{$t('read_more')}}</a>
          </div>
          <div class="bg-light text-dark p-2 mt-5">
            <h3 class="fw-bold mb-0 text-poppins">{{ $t('details') }}</h3>
          </div>
          <ul class="list-unstyled p-2">
            <li class="py-1">
              {{ $t('landing.social_video_monetization.your_music_on_instagram_stories') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing.social_video_monetization.your_music_on_facebook_stories') }}
              <i class="fa fa-check text-success pull-right mt-1"></i>
            </li>
            <li class="py-1">
              {{ $t('landing.social_video_monetization.apply_for_youtube_content_id') }}
              <router-link :to="distributeNowLink" class="btn btn-primary btn-xs pull-right text-poppins">
                {{ $t('get_access') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div>
            <img src="/static/img/landing/cellphone.png" alt="Music Distribution" width="100%">
          </div>
        </div>
      </div>
      <div class="text-center mt-5">
        <router-link :to="distributeNowLink" class="btn btn-lg btn-success">
          {{ $t('distribute_now') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingArtists',
  data: function () {
    return {
      isCrawler: false,
      stores: [],
      locationSettings: {},
      distributeNowLink: '/login'
    }
  },
  created: function () {
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)
    let o = 0
    for (let i = 0; i <= 14; i++) {
      setTimeout(() => {
        this.stores.push(i)
      }, ++o * 300)
    }

    window.document.title = this.$t('landing_artists_title')
    window.$('meta[name="description"]').attr('content', this.$t('landing_artists_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_artists_description'))
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
.main-image {
  position: relative;

  .bar {
    position: absolute;
    top: 50%;
    left: -100%;
    width: 300%;
  }

  .computer {
    position: absolute;
    left: 50%;
    margin-left: -282px;
  }
}

.super {
  font-size: 3em;
}

.features-columns {
  p {
    font-size: 0.9em;
    color: #8E8E91;
  }
}

.animated-padding {
  transition: padding .1s ease-in;
  display: inline-block;

  &:hover {
    padding: 0 !important;
  }
}

@media screen and (max-width:576px) {
  .col-store-mobile {
    flex: 0 0 33%;
    max-width: 33%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingArtists.vue